import { NgModule } from '@angular/core';
import { CurrentUserService } from './current-user.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [MatSnackBarModule],
  providers: [CurrentUserService],
})
export class CurrentUserModule {}
